import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { postData } from "../../services/generalService";
import { AdjustmentReversalObj } from "../../utils/types";

const initialState: AdjustmentReversalObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const postAdjustmentReversalTransaction = createAsyncThunk(
  "loans/postAdjustmentReversalTransaction",
  async (formData: { url: string; postsData: {} }, thunkAPI) => {
    const { url, postsData } = formData;
    try {
      const data = await postData(url, postsData, true);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const postAdjustmentReversalTransactionSlice = createSlice({
  name: "postAdjustmentReversalTransaction",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postAdjustmentReversalTransaction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postAdjustmentReversalTransaction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(postAdjustmentReversalTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default postAdjustmentReversalTransactionSlice.reducer;
